import { __ } from '@wordpress/i18n'
import { countries } from '../shared/countries'
import { states, statesCH } from '../shared/states'
import { getLangCode } from 'scripts/utils'

export default {
  labels: {
    name: __('Name', 'dhsv_theme'),
    submit: __('Submit', 'dhsv_theme'),
    masterData: __('Ihre Stammdaten', 'dhsv_theme'),
    yourBusiness: __('Sie und Ihr Business', 'dhsv_theme'),
    paymentInformation: __('Zahlungsinformationen', 'dhsv_theme'),
    backStep: __('Zurück zu Schritt', 'dhsv_theme'),
    forwardStep: __('Weiter zu Schritt', 'dhsv_theme'),
    step1Headline: __('Ihre Kontaktdaten', 'dhsv_theme'),
    step2Headline: __('Details zu Ihnen und Ihrem Business', 'dhsv_theme'),
    step3Headline: __('Zahlungsinformationen', 'dhsv_theme'),
    stepStr: __('Schritt', 'dhsv_theme'),
    mandatoryFields: __(
      'Die mit (*) markierten Felder sind Pflichtfelder',
      'dhsv_theme'
    ),
    partnerUnternehmen: __('Name Ihres Unternehmens', 'dhsv_theme'),
    partnerAnrede: __('Anrede', 'dhsv_theme'),
    partnerVorname: __('Vorname', 'dhsv_theme'),
    partnerName: __('Name', 'dhsv_theme'),
    partnerPosition: __('Position', 'dhsv_theme'),
    partnerStrasse: __('Straße/Postfach', 'dhsv_theme'),
    partnerStrasseCH: __('Strasse/Postfach', 'dhsv_theme'),
    partnerPLZ: __('PLZ', 'dhsv_theme'),
    partnerOrt: __('Ort', 'dhsv_theme'),
    partnerBundesland: __('Bundesland/Kanton', 'dhsv_theme'),
    partnerLand: __('Land', 'dhsv_theme'),
    partnerEmail: __('Ihre geschäftliche E-Mail', 'dhsv_theme'),
    partnerURL: __('Homepage', 'dhsv_theme'),
    partnerTelefon: __('Ihre Telefonnummer', 'dhsv_theme'),
    partnerHandynr: __('Ihre Mobilfunknummer', 'dhsv_theme'),
    partnerUSTID: __('Umsatzsteuer-ID', 'dhsv_theme'),
    hearAboutUs: __('Wie sind Sie auf uns aufmerksam geworden?', 'dhsv_theme'),
    partnerKundenafrage: __(
      'Kundenanfrage nach bestimmter Lösung',
      'dhsv_theme'
    ),
    partnerGoogleSuche: __('Google-Suche', 'dhsv_theme'),
    partnerAnfrageHerstellerWebsite: __(
      'Anfrage über Hersteller-Website',
      'dhsv_theme'
    ),
    partnerAndereWebsite: __('Andere Website', 'dhsv_theme'),
    partnerEmpfehlungVon: __('Empfehlung', 'dhsv_theme'),
    partnerEvent: __('Event', 'dhsv_theme'),
    partnerWebinar: __('Webinar', 'dhsv_theme'),
    partnerSonstiges: __('Sonstiges', 'dhsv_theme'),
    partnerUnternehmenHauptberuflich: __(
      'Führen Sie Ihr Unternehmen hauptberuflich?',
      'dhsv_theme'
    ),
    partnerMitarbeiter: __(
      'Wie viele Mitarbeiter sind in Ihrem Unternehmen beschäftigt?',
      'dhsv_theme'
    ),
    partnerUmsatz: __(
      'In welche Umsatzgröße dürfen wir Sie einordnen?',
      'dhsv_theme'
    ),
    partnerAnteilHardware: __('Davon Hardware (in %)', 'dhsv_theme'),
    partnerAnteilSoftware: __('Davon Software (in %)', 'dhsv_theme'),
    partnerAnteilDienstleistung: __(
      'Davon Dienstleistung (in %)',
      'dhsv_theme'
    ),
    numberEmployees: __('Anzahl der Mitarbeiter', 'dhsv_theme'),
    companySize: __('Unternehmensgröße', 'dhsv_theme'),
    cloudSavvy: __(
      'Wie Cloud-affin sind Ihr Unternehmen und Ihre Kunden?',
      'dhsv_theme'
    ),
    very: __('Sehr', 'dhsv_theme'),
    little: __('Ein bisschen', 'dhsv_theme'),
    neither: __('Weder noch', 'dhsv_theme'),
    barely: __('Kaum', 'dhsv_theme'),
    not: __('Gar nicht', 'dhsv_theme'),
    virtualEnvironmentsAmongClients: __(
      'Wie hoch ist der Anteil virtueller Umgebungen bei den von Ihrem Unternehmen betreuten Kunden?',
      'dhsv_theme'
    ),
    whichHypervisor: __(
      'Welchen Hypervisor setzen Sie hauptsächlich ein?',
      'dhsv_theme'
    ),
    other: __('Anderer', 'dhsv_theme'),
    businessModel: __(
      'Würden Sie das Geschäftsmodell Ihres Unternehmens eher als "klassisches IT-Systemhaus" oder als "Managed Services Provider" beschreiben?',
      'dhsv_theme'
    ),
    partnerKlassischesSystemhaus: __('Klassisches Systemhaus', 'dhsv_theme'),
    partnerBeides2: __('Beides', 'dhsv_theme'),
    whichManufacturers: __(
      'An welchen Herstellern oder Bereichen sind Sie besonders interessiert?',
      'dhsv_theme'
    ),
    belongPurchasingAssociation: __(
      'Gehören Sie einem Einkaufsverbund an?',
      'dhsv_theme'
    ),
    partnerVerbund: __('Einkaufsverbund', 'dhsv_theme'),
    tradeLicence: __('Gewerbenachweis', 'dhsv_theme'),
    tradeLicenceCH: __('Handelsregisterauszug', 'dhsv_theme'),
    uploadTypes: __(
      'Bitte fügen Sie hier Ihren Gewerbenachweis als PDF, PNG, JPG oder TIF ein',
      'dhsv_theme'
    ),
    uploadTypesCH: __(
      'Bitte fügen Sie hier Ihren Handelsregisterauszug als PDF, PNG, JPG oder TIF ein',
      'dhsv_theme'
    ),

    gdpr: __(
      'Ich habe die Datenschutzerklärung gelesen und stimme der Verarbeitung meiner Daten zu.',
      'dhsv_theme'
    ),
    creditCard: __('Per Kreditkarte', 'dhsv_theme'),
    invoice: __('Per Rechnung', 'dhsv_theme'),
    paypal: __('Per PayPal', 'dhsv_theme'),
    directDebit: __(
      'Per Lastschrift (SEPA) – Profitieren Sie von 14 Tagen Zahlungsziel.',
      'dhsv_theme'
    ),
    partnerZahlung: __('Zahlungsart', 'dhsv_theme'),
    partnerKontoinhaber: __('Kontoinhaber', 'dhsv_theme'),
    partnerKreditinstitut: __('Kreditinstitut', 'dhsv_theme'),
    partnerAnmerkungen: __('Anmerkungen', 'dhsv_theme'),
    partnerYsnSepaReaded: __(
      'Ich habe die Erklärung gelesen und bin damit einverstanden.',
      'dhsv_theme'
    ),
    partnerGdpr: __(
      'Ja, ich stimme zu, dass die Vereinbarung zur Verarbeitung im Auftrag nach Art. 28 Abs. 3 DSGVO automatisch zustande kommt, sobald dies aus rechtlichen Gründen und aufgrund der von mir erworbenen Produkte nötig ist.',
      'dhsv_theme'
    ),
    partnerGdpr2:
      getLangCode() === 'de-ch'
        ? __(
            'Ja, ich akzeptiere die <a target="_blank" href="https://www.ebertlang.ch/agb/agb.pdf">Allgemeinen Geschäftsbedingungen</a>.',
            'dhsv_theme'
          )
        : __(
            'Ja, ich akzeptiere die <a target="_blank" href="https://www.ebertlang.com/agb/agb.pdf">Allgemeinen Geschäftsbedingungen</a>.',
            'dhsv_theme'
          ),
    gdprStr: __('Die Datenschutzbestimmungen finden Sie', 'dhsv_theme'),
    here: __('hier', 'dhsv_theme'),
    send: __('Abschicken', 'dhsv_theme'),
  },
  selectOptions: {
    partnerBundesland: getLangCode() === 'de-ch' ? statesCH : states,
    partnerLand: countries,
    strAnrede: {
      Herr: __('Herr', 'dhsv_theme'),
      Frau: __('Frau', 'dhsv_theme'),
      Divers: __('Divers', 'dhsv_theme'),
    },
  },
  successMessage: __(
    'Vielen Dank! Wir haben Ihre Angaben erhalten und melden uns zeitnah bei Ihnen!',
    'dhsv_theme'
  ),
  validationMessages: {
    email: __('Bitte geben Sie eine gültige E-Mail-Adresse an', 'dhsv_theme'),
    required: __('Bitte füllen Sie das Feld aus', 'dhsv_theme'),
    partnerYsnSepaReaded: __('Bitte füllen Sie das Feld aus', 'dhsv_theme'),
    partnerGdpr: __(
      'Bitte stimmen Sie der Übermittlung Ihrer Daten zu',
      'dhsv_theme'
    ),
    partnerGdpr2: __('Bitte stimmen Sie den AGB zu', 'dhsv_theme'),
    limitExceeded: __('Bitte geben sie maximal %d Zeichen ein', 'dhsv_theme'),
  },
}
